package fr.labodoc.healthProfessional.webApp.data.model

data class MedicalSpecialityModel(
  val id: String,
  val name: String,
  val medicalInterests: Set<MedicalInterestModel>
)
